import { Dialog, DialogProps } from "@minuthq/meatball-ui-react"

import { BaseWizard } from "src/ui/Wizard/BaseWizard"
import { IDialogWizardStep } from "src/ui/Wizard/wizardTypes"

type TDialogWizardProps = Pick<
  DialogProps,
  "open" | "error" | "description" | "loading"
> & {
  steps: IDialogWizardStep[]
  currentStep: number
  onNext?: () => void
  onBack: () => void
}

export function DialogWizard({
  steps,
  open,
  onBack,
  onNext,
  currentStep,
  error,
  description,
  loading,
}: TDialogWizardProps) {
  return (
    <Dialog
      open={open}
      onClose={(reason) => {
        if (
          currentStep !== 0 &&
          (reason === "click_outside" || reason === "escape_key")
        ) {
          return
        }

        const stepOnBack = steps[currentStep]?.onBack

        if (stepOnBack) {
          stepOnBack()
        } else {
          onBack()
        }
      }}
      onConfirm={steps[currentStep]?.onNext ?? onNext}
      title={steps[currentStep]?.title}
      closeLabel={steps[currentStep]?.backButtonLabel}
      confirmLabel={steps[currentStep]?.nextButtonLabel}
      error={error}
      description={steps[currentStep]?.description ?? description}
      loading={steps[currentStep]?.loading ?? loading}
      confirmButtonProps={steps[currentStep]?.confirmButtonProps}
      formId={steps[currentStep]?.formId}
    >
      <BaseWizard currentStep={currentStep} steps={steps} hideButtonRow />
    </Dialog>
  )
}
